import { css } from 'styled-components';

export const uprightTippyStyling = css`
  & {
    background-color: #f9f9f9;
    color: #141414;
    border: 2px solid #eeeeee;
    border-radius: 2px;
    overflow: visible;
    font-size: 14px;
  }
  &[data-animatefill] {
    background-color: #f9f9f9;
  }
  & .tippy-backdrop {
    background-color: transparent;
  }
  & .tippy-content {
    text-align: left;
  }
  & .tippy-arrow {
    display: none;
  }
  &[x-placement^='top'] .tippy-arrow {
    border-bottom-color: #dddddd;
  }
  &[x-placement^='bottom'] .tippy-arrow {
    border-bottom-color: #dddddd;
  }
  &[x-placement^='left'] .tippy-arrow {
    border-left-color: #dddddd;
  }
  &[x-placement^='right'] .tippy-arrow {
    border-right-color: #dddddd;
  }
`;
